import { UiTheme } from '../../theme'

export default (theme: UiTheme) => {
  const commonPaddings = {
    paddingTop: theme.settings.spacing.large,
    paddingRight: theme.settings.spacing.xLarge,
    paddingBottom: theme.settings.spacing.large,
    paddingLeft: theme.settings.spacing.xLarge,
  }

  const tightPaddings = {
    paddingTop: theme.settings.spacing.large,
    paddingRight: theme.settings.spacing.large,
    paddingBottom: theme.settings.spacing.large,
    paddingLeft: theme.settings.spacing.large,
  }

  const flushPaddings = {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  }

  return {
    modal: {
      base: {
        outline: 'none',
        marginTop: theme.settings.spacing.xxLarge,
        marginBottom: theme.settings.spacing.xxLarge,
        maxWidth: '100vw',
        width: '520px',
        backgroundColor: 'white',
        boxShadow: theme.settings.shadows.elevation[2],
        borderRadius: theme.settings.borderRadiuses.regular,
        transition: `
        opacity 500ms ${theme.settings.timingFunctions.easeInOutBack},
        transform 500ms ${theme.settings.timingFunctions.easeInOutBack},
        background-color 150ms ${theme.settings.timingFunctions.easeInOutQuad}
      `,
        opacity: 0,
        transform: 'translateY(-30px)',

        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
          transform: 'none',
        },
      },
      visible: {
        opacity: 1,
        transform: 'translate(0)',
      },
      fixedHeight: {
        maxHeight: `calc(100vh - ${theme.settings.spacing.xxLarge} - ${theme.settings.spacing.xxLarge})`,
      },
      centered: {
        width: '460px',
        marginTop: '30vh',
      },
    },

    content: {
      base: {
        ...commonPaddings,
        ...theme.typography.body,
        color: '#404e59',
        overflowX: 'hidden',
      },

      tight: {
        ...tightPaddings,
      },

      flush: {
        ...flushPaddings,
      },
    },

    header: {
      base: {
        ...commonPaddings,
        ...theme.typography.headings.normal,
        color: 'white',
        borderTopLeftRadius: theme.settings.borderRadiuses.regular,
        borderTopRightRadius: theme.settings.borderRadiuses.regular,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minHeight: '70px',
        boxSizing: 'border-box',
      },
      variants: {
        secondary: {
          backgroundColor: theme.colors.accents.secondary,
        },
        primary: {
          backgroundColor: theme.colors.accents.primary,
        },
      },
      hasTopbar: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
    },

    topbar: {
      base: {
        ...theme.typography.small,
        color: 'white',
        paddingTop: theme.settings.spacing.small,
        paddingBottom: theme.settings.spacing.small,
        paddingLeft: theme.settings.spacing.medium,
        paddingRight: '40px',
        minHeight: '41px',
        borderTopLeftRadius: theme.settings.borderRadiuses.regular,
        borderTopRightRadius: theme.settings.borderRadiuses.regular,
        boxSizing: 'border-box',
      },
      variants: {
        secondary: {
          borderBottom: theme.settings.borders.dim,
          backgroundColor: theme.colors.accents.secondary,
        },
        primary: {
          borderBottom: theme.settings.borders.dim,
          backgroundColor: theme.colors.accents.primary,
        },
      },
    },

    footer: {
      base: {
        ...commonPaddings,
        backgroundColor: '#f7f9fb',
        borderTop: theme.settings.borders.regular,
        borderRadius: `0 0 ${theme.settings.borderRadiuses.regular} ${theme.settings.borderRadiuses.regular}`,
        textAlign: 'right',
        minHeight: '70px',
        boxSizing: 'border-box',

        '>:not(:last-child)': {
          marginRight: theme.settings.spacing.small,
        },
      },

      tight: {
        ...tightPaddings,
      },

      flush: {
        ...flushPaddings,
      },
    },

    closeButton: {
      base: {
        position: 'absolute',
        top: '15px',
        right: '20px',
        borderRadius: theme.settings.borderRadiuses.regular,
        margin: '0',
      },
      hasTopbar: {
        top: '0px',
        right: '0px',
        borderRadius: `0 ${theme.settings.borderRadiuses.regular} 0 0`,
      },
    },

    topbarButton: {
      base: {
        ...theme.typography.body,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        cursor: 'pointer',
        border: 'none',
        height: '40px',
        margin: '-10px 0',
        outline: 'none',
        padding: 0,
        width: '40px',

        '.intent-mouse &:focus': {
          boxShadow: 'none',
        },
        // SMELL Fixes issue when button is wrapped in tooltip and
        // disabled it will not trigger the onMouseLeave event,
        // leaving the tooltip open.
        '&:disabled': {
          pointerEvents: 'none',
        },
      },
      variants: {
        primary: {
          backgroundColor: theme.colors.accents.primary,
          ':hover': {
            backgroundColor: theme.colors.accents.primaryHover,
          },
          ':active': {
            backgroundColor: theme.colors.accents.primaryActive,
          },
          ':focus': {
            boxShadow: `0 0 0 3px ${theme.colors.accents.primaryBorder}`,
          },
          '[disabled]': {
            cursor: 'default',
            backgroundColor: theme.colors.accents.primary,
            boxShadow: 'none',
          },
        },
        secondary: {
          backgroundColor: theme.colors.accents.secondary,
          ':hover': {
            backgroundColor: theme.colors.accents.secondaryHover,
          },
          ':active': {
            backgroundColor: theme.colors.accents.secondaryActive,
          },
          ':focus': {
            boxShadow: `0 0 0 3px ${theme.colors.accents.secondaryBorder}`,
          },
          '[disabled]': {
            cursor: 'default',
            backgroundColor: theme.colors.accents.secondary,
            boxShadow: 'none',
          },
        },
      },
    },
  }
}
